export const FETCH_SUGGESTED_PROPERTIES_REQUEST = 'FETCH_SUGGESTED_PROPERTIES_REQUEST'
export const FETCH_SUGGESTED_PROPERTIES_SUCCESS = 'FETCH_SUGGESTED_PROPERTIES_SUCCESS'
export const FETCH_SUGGESTED_PROPERTIES_FAILURE = 'FETCH_SUGGESTED_PROPERTIES_FAILURE'
export const RESET_SUGGESTED_PROPERTIES = 'RESET_SUGGESTED_PROPERTIES'

export const SUGGESTED_PROPERTIES_STATE = 'suggested'
